import { useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../Contexts/UserContext";
import { siteService } from "../Services/siteService";
import captchaImage from '../Assets/Images/captcha.jpg'
import { useLocation } from "react-router";
import toast from "react-hot-toast";

const Contact = (props) => {
    let location = useLocation();
    const nameRef = useRef(null);
    const containerRef = useRef(null);
    const { user, showAlert } = useContext(UserContext);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const message = location.state?.message ?? "";
    const source = location.state?.source ?? "";

    const initialValues = {
        firstname: user.profile?.name ?? '',
        company: '',
        industry: '',
        organizationType: '',
        designation: '',
        email: user.email ?? user.profile?.communication_email ?? '',
        phone: user.profile?.communication_phone_number ?? '',
        message: message ?? '',
        captcha: ''
    };

    const [values, setValues] = useState({...initialValues});

    useEffect(() => {
        setValues({...values, message: message});
        if(!!message) {
            nameRef.current.focus();
            containerRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [message]);

    useEffect(() => {
        setValues({...initialValues});
    }, [user]);

    useEffect(() => {
        if(values.firstname != "" && (values.email != "" || values.phone != "") && values.message != "") {
            setShowCaptcha(true);
        } else {
            setShowCaptcha(false);
        }
    }, [values]);

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setValues({
          ...values,
          [name]: value
        });
    }

    const handleSubmit  = () => {
        if (!values.firstname.trim()) {
            toast.error('Please enter the name');
            return;
        }
        if(!values.email.trim() && !values.phone.trim()) {
            toast.error('Please enter a valid email id or phone number');
            return;
        }
        if(values.email.trim() && ! (/(.+)@(.+){2,}\.(.+){2,}/.test(values.email.trim()) )) {
            toast.error('Please enter a valid email id');
            return;
        }
        if (!values.message.trim()) {
            toast.error('Please enter the Message');
            return;
        }
        if(values.industry == "") {
            toast.error("Please select Industry");
            return;
        }
        if(values.organizationType == "") {
            toast.error("Please select Organization Type");
            return;
        }
        if(values.designation == "") {
            toast.error("Please select Role/Designation");
            return;
        }
        if(!values.captcha.trim()) {
            toast.error('Please enter the Captcha');
            return;
        }
        if(values.captcha.trim() != "AEDRB") {
            toast.error("Please enter valid Captcha");
            return;
        }

        let contactUsMessage = values.message;
        if (!!source?.trim()) {
            contactUsMessage = `${contactUsMessage} <br /><b>User has contacted from ${source} page</b>`;
        }

        let data = {
            name: values.firstname.trim(),
            email: values.email.trim(),
            phoneNo: values.phone.trim(),
            message: values.message,
            industry: values.industry,
            organizationType: values.organizationType,
            designation: values.designation,
            location: window.location.href
        };

        submitContactUs(data);
    }

    const submitContactUs = (data) => {
        return siteService.contactus(data)
        .then((result) => { 
            toast.success('Submitted successfully.');
            setValues(initialValues);
        })
        .catch(error => {
            console.log('Error in Contact us Form Submission', error);
            toast.error('Submission failed! Please try again.');
        });
    }

    return (
        <section className="contact-section" id="contactus">
            <div className="container" ref={containerRef}>
                <div className="stay-connected">
                    <div className="left-content">
                        <h3>
                            STAY<br />
                            In Touch
                        </h3>
                        <p>We’d love to hear from you! <br/>
                            If you are interested in scheduling a demo or <br/>
                            Would like to know more, please contact us. </p>
                    </div>
                    <div className="right-form">
                        <div className="contact-form">
                            <div className="row">
                                <div className="col-xs-12 col-md-6">
                                    <input type="text" ref={nameRef} className="form-control" placeholder="Name*" name="firstname" value={values.firstname} onChange = {(e) => handleInputChange(e)} />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <select className="form-select" name="industry" value={values.industry} onChange={(e) => handleInputChange(e)}>
                                        <option value="">Select Industry *</option>
                                        <option value="Agriculture">Agriculture</option>
                                        <option value="Economic Development">Economic Development</option>
                                        <option value="Engineering and Construction">Engineering and Construction</option>
                                        <option value="Environment and Natural Resources">Environment and Natural Resources</option>
                                        <option value="Highways and Roads">Highways and Roads</option>
                                        <option value="Insurance">Insurance</option>
                                        <option value="Law Enforcement and Justice">Law Enforcement and Justice</option>
                                        <option value="Mining">Mining</option>
                                        <option value="National Security">National Security</option>
                                        <option value="Oil and Gas">Oil and Gas</option>
                                        <option value="Public Administration and Policy">Public Administration and Policy</option>
                                        <option value="Railroad">Railroad</option>
                                        <option value="Real Estate">Real Estate</option>
                                        <option value="Urban and Regional Planning">Urban and Regional Planning</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <input type="text" className="form-control" placeholder="Email**" name="email" value={values.email} onChange = {(e) => handleInputChange(e)} />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <select className="form-select" name="organizationType" value={values.organizationType} onChange={(e) => handleInputChange(e)}>
                                        <option value="">Select Organization Type *</option>
                                        <option value="City Government">City Government</option>
                                        <option value="State Government">State Government</option>
                                        <option value="Regional Government">Regional Government</option>
                                        <option value="National Government">National Government</option>
                                        <option value="Nonprofit and NGOs">Nonprofit and NGOs</option>
                                        <option value="Private/Business">Private/Business</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <input type="text" className="form-control" placeholder="Phone Number**" name="phone"  value={values.phone} onChange = {(e) => handleInputChange(e)} />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <select className="form-select" name="designation" value={values.designation} onChange={(e) => handleInputChange(e)}>
                                        <option value="">Select Role/Designation *</option>
                                        <option value="Director">Director</option>
                                        <option value="Department Head">Department Head</option>
                                        <option value="Team Lead">Team Lead</option>
                                        <option value="Domain Expert">Domain Expert</option>
                                        <option value="Technologist">Technologist</option>
                                        <option value="Procurement Officer">Procurement Officer</option>
                                        <option value="Support Staff">Support Staff</option>
                                        <option value="Others">Others</option>
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-12">
                                    <textarea className="form-control" id="" cols="30" rows="3" placeholder="Message*" name="message" value={values.message} onChange = {(e) => handleInputChange(e)}></textarea>
                                </div>
                                {
                                    showCaptcha && 
                                    <>
                                        <div className="col-xs-12 col-md-12">
                                            <input type="text" className="form-control" placeholder="Please enter below text*" name="captcha" value={values.captcha} onChange = {(e) => handleInputChange(e)} />
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <img src={captchaImage} />
                                        </div>
                                    </>
                                }
                            </div>
                            <button type="submit" className="btn btn-submit" onClick={handleSubmit}>SUBMIT</button>
                            <div>&nbsp;</div>
                            <div>
                                <i>** Please provide one of the email or phone number</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;